<template>
  <div>
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
      <title>videowall</title>
      <path fill="#679940"
        d="M30,5.75H2a1,1,0,0,0-1,1v20a1,1,0,0,0,1,1H30a1,1,0,0,0,1-1v-20A1,1,0,0,0,30,5.75Zm-1,10H17v-8H29Zm-14-8v8H3v-8Zm-12,18v-8H15v8Zm14,0v-8H29v8Z"
      />
    </svg>
  </div>
</template>

<script>
export default {
  name: "VideowallIcon"
};
</script>


// WEBPACK FOOTER //
// src/icons/VideowallIcon.vue